/*! @pentacode/ui v0.1.0 */
import { t as e } from "./styledElement-Dm1irIE2.js";
import { t } from "./decorateMetadata-BhwOl-pv.js";
import { t as n } from "./decorate-DHgd5sZx.js";
import { t as r } from "./css-build-DICbZE45.js";
import { LitElement as i, html as a } from "lit";
import { customElement as o, property as s } from "lit/decorators.js";
//#region src/utils/reduced-motion.ts
var c = "(prefers-reduced-motion: reduce)";
function l() {
	return typeof window < "u" && typeof window.matchMedia == "function" && window.matchMedia(c).matches;
}
var u = class {
	constructor(e) {
		this.matches = l(), this._onChange = () => {
			this.matches = this._query?.matches ?? !1, this._host.requestUpdate();
		}, this._host = e, e.addController(this);
	}
	hostConnected() {
		typeof window < "u" && typeof window.matchMedia == "function" && (this._query = window.matchMedia(c), this.matches = this._query.matches, this._query.addEventListener("change", this._onChange));
	}
	hostDisconnected() {
		this._query?.removeEventListener("change", this._onChange);
	}
}, d = r(":host{line-height:0;display:inline-block}:host>img{object-fit:contain;width:1.5em;height:1.5em;filter:var(--darkmode-filter-reversal);display:block}"), f = "/img/weather-icons";
function p(e) {
	f = e;
}
var m = class extends e(i) {
	constructor(...e) {
		super(...e), this.icon = "not-available", this.animated = !1, this.label = "", this._motion = new u(this), this.styles = d;
	}
	render() {
		let e = this.animated && !this._motion.matches ? "animated" : "static", t = `${f}/${e}/${this.icon || "not-available"}.svg`;
		return a`<img src=${t} alt=${this.label} loading="lazy" />`;
	}
};
n([s(), t("design:type", Object)], m.prototype, "icon", void 0), n([s({
	type: Boolean,
	reflect: !0
}), t("design:type", Object)], m.prototype, "animated", void 0), n([s(), t("design:type", Object)], m.prototype, "label", void 0), m = n([o("ptc-ui-weather-icon")], m);
//#endregion
export { p as n, m as t };

//# sourceMappingURL=weather-icon-BE0DhyCq.js.map